import { ChevronRightIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"

const Breadcrumbs = ({ items }) => (
  <nav className="flex" aria-label="Breadcrumb">
    <ol className="flex items-center">
      {items.map((item, index) => (
        <li key={index}>
          <div className="flex items-center">
            {index > 0 && <ChevronRightIcon className="h-4 w-4 mx-2 flex-shrink-0 text-gray-500" aria-hidden="true" />}

            <a href={item.href} className="mb-1 text-sm font-medium text-gray-300 hover:text-white">
              {item.caption}
            </a>
          </div>
        </li>
      ))}
    </ol>
  </nav>
)

Breadcrumbs.propTypes = {
  items: PropTypes.array.isRequired,
}

export default Breadcrumbs
